import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faDollarSign, faInfoCircle, faArrowRight, faAngleRight, faAngleLeft, faAngleDown, faCheck,
  faSearch, faPlusCircle, faHome, faBell, faCog, faPlus, faBars,
  faCheckCircle, faTimesCircle, faTimes, faUpload, faEye, faEyeSlash,
  faCamera, faEdit, faTrash, faShareAlt, faList, faSync, faChevronRight,
  faChevronCircleRight, faChevronCircleLeft, faQuestionCircle, faImage,
  faLink, faClock, faThLarge, faPlay, faDownload, faStar, faCalendar,
  faGlobe, faThumbsUp, faThumbsDown, faEnvelope, faPen, faInfo, faMinusCircle,
  faExclamation, faMapMarkerAlt, faUser, faBriefcase, faFilter, faChevronLeft, faCircle, faChevronCircleDown, faChevronCircleUp,
  faChevronUp, faChevronDown, faExternalLinkAlt, faCopy, faCalendarTimes, faArrowLeft
} from '@fortawesome/free-solid-svg-icons'

config.autoAddCss = false

library.add(
  faArrowRight, faAngleRight, faAngleLeft, faAngleDown, faSearch, faPlusCircle, faHome,
  faBell, faCog, faPlus, faBars, faCheckCircle, faTimesCircle, faTimes, faUpload,
  faEye, faEyeSlash, faCheck, faCamera, faEdit, faTrash, faSync, faShareAlt, faList, faCalendar,
  faChevronCircleRight, faChevronCircleLeft, faQuestionCircle, faThLarge,
  faImage, faLink, faClock, faPlay, faDownload, faStar,
  faChevronRight, faGlobe, faThumbsUp, faThumbsDown, faEnvelope, faDollarSign, faInfoCircle, faPen, faInfo, faMinusCircle,
  faExclamation, faMapMarkerAlt, faUser, faBriefcase, faFilter, faChevronLeft, faCircle, faChevronCircleDown, faChevronCircleUp,
  faChevronUp, faChevronDown, faExternalLinkAlt, faCopy, faCalendarTimes, faArrowLeft
)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
